import React from 'react';
import Head from 'next/head';

import Header from './header/Header';
import HeadingBlock from './heading-block/HeadingBlock';
import QuotesBlock from './quotes-block/QuotesBlock';
import FeaturesBlock from './features-block/FeaturesBlock';
import UseColumnsBlock from './use-columns-block/UseColumnsBlock';
import AboutFooter from './footer/AboutFooter';

export default function AboutPage() {
  return (
    <>
      <Head>
        {/* Google tag (gtag.js) */}
        <script async src="https://www.googletagmanager.com/gtag/js?id=AW-17307896476"></script>
        <script
          dangerouslySetInnerHTML={{
            __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'AW-17307896476');
          `,
          }}
        />
      </Head>
      <Header />
      <HeadingBlock />
      <QuotesBlock />
      <FeaturesBlock />
      <UseColumnsBlock />
      <AboutFooter />
    </>
  );
}
